import { render, staticRenderFns } from "./addInvite.vue?vue&type=template&id=0deca44e&scoped=true&"
import script from "./addInvite.vue?vue&type=script&lang=js&"
export * from "./addInvite.vue?vue&type=script&lang=js&"
import style0 from "./addInvite.vue?vue&type=style&index=0&id=0deca44e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0deca44e",
  null
  
)

export default component.exports